module.exports = __webpack_public_path__ + "img/ztc.1aac499.png";